import SecureLS from 'secure-ls'

const secureLs = new SecureLS()

const setupInterceptors = (apiInstance) => {
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        secureLs.removeAll()
        window.location.href = '/login'
      }
      return Promise.reject(error)
    },
  )
}

export default setupInterceptors
